import React from 'react';
import Login from "../components/Login";
import './pages.sass'
import Footer from "../components/Footer";

const LogInPage = () => {
    return (
        <div className={'login_page_container'}>
            <Login />

        </div>
    );
};

export default LogInPage;